import { render, staticRenderFns } from "./points_setting.vue?vue&type=template&id=46bafda5&scoped=true&"
import script from "./points_setting.vue?vue&type=script&lang=ts&"
export * from "./points_setting.vue?vue&type=script&lang=ts&"
import style0 from "./points_setting.vue?vue&type=style&index=0&id=46bafda5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bafda5",
  null
  
)

export default component.exports